import React from 'react';
import DecimalInput from './DecimalFormInput';

const DecimalFormGroup = ({id, name, label, onChange, isRequired = false, isDisabled = false, value, ...props}) => {
    const inputProps = {name, value, onChange};

    return (
        <div className="form-group">
            <label htmlFor={name} className="control-label col-md-4">
                {label}{isRequired ? '*' : ''}
            </label>
            <div className="col-md-8">
                <DecimalInput {...inputProps}/>
            </div>
        </div>
    );
}

export default DecimalFormGroup;
